module.exports = __webpack_public_path__ + "static/media/swimming-pool.d19fbc00.svg";